import { useState } from "react";
import { CircleHelp } from "lucide-react";

import { QuestionsDialog } from "@/components/growth/GrowthDialogs";
import { GHOST_BUTTON } from "@/components/growth/GrowthParts";
import { useGrowth } from "@/growth/useGrowth";

/** "Questions for you" on Your Agent, for pilot workspaces: a button with the open count and the questions popup. */
export default function QuestionsEntry({ agentName }) {
  const growth = useGrowth({ refreshMs: 0 });
  const [open, setOpen] = useState(false);
  const questions = growth.data?.questions || [];
  const count = questions.filter((question) => question.status === "open").length;
  return (
    <>
      <button type="button" className={GHOST_BUTTON} onClick={() => setOpen(true)} data-testid="agent-questions-button" data-count={count}>
        <CircleHelp size={14} /> Questions for you{count ? ` · ${count}` : ""}
      </button>
      <QuestionsDialog open={open} onClose={() => setOpen(false)} questions={questions} canAct={Boolean(growth.data?.capabilities?.act)} busyKey={growth.busyKey} onAnswer={growth.actions.answerQuestion} onSkip={growth.actions.skipQuestion} agentName={agentName || "Your agent"} />
    </>
  );
}
